import { Box } from '@palmetto/palmetto-components';

import { ProgramType, warrantyMap, WarrantyType } from 'types';

import EventBy from './EventBy';

const SabalWarrantyPricingSettingCreated = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <EventBy event={event} /> created a {event.data.programType} Warranty Pricing Setting:{' '}
      {event.data.value.warrantyProvider} -{' '}
      {warrantyMap[event.data.programType as ProgramType][event.data.value.warrantyType as WarrantyType]}
    </Box>
  );
};

export default SabalWarrantyPricingSettingCreated;
